
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("38FZt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $49aed27f5f85aa5c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $956it = parcelRequire("956it");

var $cSXp8 = parcelRequire("cSXp8");

var $2imLM = parcelRequire("2imLM");

var $1M2hR = parcelRequire("1M2hR");

var $koAZ4 = parcelRequire("koAZ4");

var $ikoPM = parcelRequire("ikoPM");

var $4cTDP = parcelRequire("4cTDP");

var $gdeTc = parcelRequire("gdeTc");

var $4Qvpr = parcelRequire("4Qvpr");

var $e7yO3 = parcelRequire("e7yO3");


var $lWu0k = parcelRequire("lWu0k");

var $1XQ0l = parcelRequire("1XQ0l");

var $dymtJ = parcelRequire("dymtJ");
/**
 * This component serves as the interface for collecting user feedback within the application.
 * It leverages various hooks to manage locale settings and user context, ensuring a tailored
 * feedback collection experience. The component dynamically displays a feedback dialog when
 * conditions are met, facilitating the submission and processing of user feedback. It
 * incorporates analytics to track feedback submissions and employs a notification system to
 * confirm successful submissions to the user. This approach not only enriches the user
 * experience by making feedback submission intuitive but also aids in gathering valuable
 * insights from users efficiently.
 */ const $49aed27f5f85aa5c$var$FeedbackRenderer = ()=>{
    const locale = (0, $1M2hR.useNativeLocale)();
    const [{ isFeedbackCollectorOpen: isFeedbackCollectorOpen, feedbackCollectorId: feedbackCollectorId, additionalFields: additionalFields, feedbackContext: feedbackContext, feedbackGroupId: feedbackGroupId, onClose: onClose, onSubmit: onSubmit, entrypointId: entrypointId, renderCustomContent: renderCustomContent, ...feedbackCollectorProps }, { closeFeedbackCollector: closeFeedbackCollector, resetFeedbackCollectorState: resetFeedbackCollectorState }] = (0, $4Qvpr.useFeedbackCollector)();
    const { userFullname: userFullname, atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $koAZ4.useTenantContext)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagService)();
    const [feedbackTriggerRef] = (0, $ikoPM.useGlobalRef)((0, $0eb3f773a9c78b82$export$542a20d67952f202));
    const feedbackTimeoutRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>()=>{
            if (feedbackTimeoutRef.current) clearTimeout(feedbackTimeoutRef.current);
        }, []);
    const additionalFieldsWithContext = (0, $eJOHy.useMemo)(()=>{
        const fields = additionalFields?.slice() ?? [];
        let maybeFeedbackContext = feedbackContext;
        if (feedbackGroupId != null) {
            maybeFeedbackContext = maybeFeedbackContext || [];
            maybeFeedbackContext.push({
                id: (0, $gdeTc.EntryKeys).FEEDBACK_GROUP_ID,
                value: feedbackGroupId
            });
        }
        if (maybeFeedbackContext != null) fields.push({
            id: (0, $0eb3f773a9c78b82$export$c14d5836f440dde1),
            value: maybeFeedbackContext.map(({ id: id, value: value })=>`${id}: ${String(value)}`).join('\n')
        });
        return fields;
    }, [
        additionalFields,
        feedbackContext,
        feedbackGroupId
    ]);
    const onFeedbackSubmit = (0, $eJOHy.useCallback)((feedbackDetails)=>{
        const analyticsPayload = (0, $dymtJ.createAnalyticsPayload)(feedbackCollectorId, feedbackDetails);
        (0, $e7yO3.fireFeedbackCreatedAnalytics)(entrypointId, analyticsPayload);
        (0, $4cTDP.fg)('product-terminology-refresh') ? showFlag((0, $1XQ0l.successFlagConfig)) : showFlag((0, $1XQ0l.successFlagConfigWithoutAppify));
        onSubmit?.();
        resetFeedbackCollectorState();
    }, [
        onSubmit,
        entrypointId,
        feedbackCollectorId,
        resetFeedbackCollectorState,
        showFlag
    ]);
    const onFeedbackClose = (0, $eJOHy.useCallback)(()=>{
        closeFeedbackCollector();
        feedbackTimeoutRef.current = setTimeout(()=>{
            feedbackTriggerRef?.focus();
        }, 0);
        onClose?.();
    }, [
        closeFeedbackCollector,
        onClose,
        feedbackTriggerRef
    ]);
    const shouldRender = isFeedbackCollectorOpen && !!entrypointId;
    // Description needs to be defined in the FeedbackCollector in order for the form to be submittable
    // but because the FeedbackCollector component manages the state of the description field internally, we can't
    // directly modify it. Instead, setting descriptionDefaultValue works around this issue and allows us to
    // set the description and make the form submittable.
    // It's a wacky workaround, but it appears to be used in other places too.
    const [description, setDescription] = (0, $eJOHy.useState)('');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-feedback-collector-dialog",
        fallback: null
    }, shouldRender ? // @ts-expect-error - TS2769 - No overload matches this call.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lWu0k.LazyFeedbackCollectorDialog), {
        locale: locale,
        entrypointId: entrypointId,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        atlassianAccountId: atlassianAccountId,
        anonymousFeedback: isAnonymous,
        onClose: onFeedbackClose,
        onSubmit: onFeedbackSubmit,
        additionalFields: additionalFieldsWithContext,
        name: userFullname ?? undefined,
        customContent: renderCustomContent?.({
            setDescription: setDescription
        }),
        descriptionDefaultValue: description,
        summaryDefaultValue: description,
        ...feedbackCollectorProps
    }) : null));
};
var $49aed27f5f85aa5c$export$2e2bcd8739ae039 = $49aed27f5f85aa5c$var$FeedbackRenderer;

});
parcelRegister("1M2hR", function(module, exports) {
$parcel$export(module.exports, "useLocale", () => $22bfd94a936ddbb0$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $22bfd94a936ddbb0$export$31652d9c30d7d3f3);

var $eJOHy = parcelRequire("eJOHy");

var $jbr6p = parcelRequire("jbr6p");

var $koAZ4 = parcelRequire("koAZ4");
const $22bfd94a936ddbb0$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $jbr6p.defaultLocale);
};
const $22bfd94a936ddbb0$export$31652d9c30d7d3f3 = ()=>{
    const locale = $22bfd94a936ddbb0$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $eJOHy.useMemo)(()=>(0, $jbr6p.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});

parcelRegister("ikoPM", function(module, exports) {
$parcel$export(module.exports, "useGlobalRef", () => $339782a6d3d7436f$export$361e4f658203e95);
$parcel$export(module.exports, "useGlobalRefStoreActions", () => $339782a6d3d7436f$export$3c6c6911d09d7d8a);
$parcel$export(module.exports, "withGlobalRef", () => $339782a6d3d7436f$export$6b4b878b04fd3017);

var $eJOHy = parcelRequire("eJOHy");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $339782a6d3d7436f$var$store = (0, $GtRbT.createStore)({
    initialState: {},
    actions: {
        register: (key, ref)=>({ setState: setState })=>{
                setState({
                    [key]: ref || undefined
                });
            }
    },
    name: 'refs-store'
});
const $339782a6d3d7436f$export$4beaa3baa53198e4 = (0, $6E16M.createContainer)($339782a6d3d7436f$var$store);
const $339782a6d3d7436f$var$useGlobalRefStateSelector = (0, $iJq0l.createStateHook)($339782a6d3d7436f$var$store, {
    selector: (state, key)=>state[key]
});
const $339782a6d3d7436f$export$361e4f658203e95 = (key)=>[
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        $339782a6d3d7436f$var$useGlobalRefStateSelector(key)
    ];
const $339782a6d3d7436f$export$3c6c6911d09d7d8a = (0, $iJq0l.createHook)($339782a6d3d7436f$var$store, {
    selector: null
});
const $339782a6d3d7436f$export$6b4b878b04fd3017 = (propName, refName)=>(Component)=>(props)=>{
            const [ref] = $339782a6d3d7436f$export$361e4f658203e95(refName);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
                ...props,
                [propName]: ref
            });
        };

});

parcelRegister("gdeTc", function(module, exports) {
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PLATFORM", () => $8be836e57712489a$export$baea5c8192e79adc);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT", () => $8be836e57712489a$export$4eda1e3a4a311d13);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PRODUCT_DISCOVERY", () => $8be836e57712489a$export$5fb38521eb7ad63c);
$parcel$export(module.exports, "ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB", () => $8be836e57712489a$export$345c45dd28f28a32);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_COMMAND_PALETTE", () => $8be836e57712489a$export$8962f2e618411469);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_VIEW", () => $8be836e57712489a$export$7d7f2319141db3c5);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR", () => $8be836e57712489a$export$4725635e6fe1907a);
$parcel$export(module.exports, "ENTRY_POINT_ID_GENERATIVE_AI", () => $8be836e57712489a$export$3a50f2efd6cfd6f3);
$parcel$export(module.exports, "ENTRY_POINT_ID_AIOPS", () => $8be836e57712489a$export$5bd148c13bb23f7a);
$parcel$export(module.exports, "ENTRY_POINT_ID_COMPASS", () => $8be836e57712489a$export$b4de0744c1fd450d);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_ASSETS_REPORTING", () => $8be836e57712489a$export$1a7c42187130faf9);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_VIRTUAL_AGENT", () => $8be836e57712489a$export$e84c34a7e1dbcf78);
$parcel$export(module.exports, "ENTRYPOINT_ID_NAVIGATION_REFRESH", () => $8be836e57712489a$export$23f6d7b16d2210c1);
$parcel$export(module.exports, "ENTRY_POINT_ID_AUTODEV", () => $8be836e57712489a$export$1b65c2053cba0686);
$parcel$export(module.exports, "ENTRYPOINT_ID_PROJECT_BACKGROUNDS", () => $8be836e57712489a$export$9a234699f0515bf);
$parcel$export(module.exports, "ENTRY_POINT_ID_JOURNEY_BUILDER", () => $8be836e57712489a$export$f24169c529e6c9b5);
$parcel$export(module.exports, "ENTRY_POINT_ID_BULK_OPERATIONS", () => $8be836e57712489a$export$f849b75576b691b);
$parcel$export(module.exports, "ENTRY_POINT_ID_ADMIN_ONBOARDING_HUB", () => $8be836e57712489a$export$c0e3a1d9aa18e8eb);
$parcel$export(module.exports, "ENTRY_POINT_ID_AI_CONTEXT_RESOLUTION_PLAN_PANEL", () => $8be836e57712489a$export$7f190c8f7bc2242);
$parcel$export(module.exports, "ENTRY_POINT_ID_INDIVIDUAL_CAPACITY_PLANNING", () => $8be836e57712489a$export$8df25926ec47a767);
$parcel$export(module.exports, "EntryKeys", () => $8be836e57712489a$export$12d01b6c311a909a);
// Jira platform project feedback JSD widget configuration
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JGF/queues/custom/448
const $8be836e57712489a$export$baea5c8192e79adc = '1ff0a150-1d4f-4225-8e7b-3577fb9d9764';
const $8be836e57712489a$export$4eda1e3a4a311d13 = 'f60db8bd-1904-4af4-a0ef-f140598ebada';
const $8be836e57712489a$export$5fb38521eb7ad63c = '3508b77a-0aa1-4ad5-a397-621bd308c828';
const $8be836e57712489a$export$345c45dd28f28a32 = 'cdb5199a-4c4e-4692-b006-4e2628ed4771';
const $8be836e57712489a$export$8962f2e618411469 = '3d204590-d14a-419f-a042-f0b1a92e005b';
const $8be836e57712489a$export$7d7f2319141db3c5 = 'af9ace2f-61a9-45ac-8e67-b54f74246b94';
const $8be836e57712489a$export$4725635e6fe1907a = 'cd375e0e-ae56-4a2f-bad8-6114c617bf2f';
const $8be836e57712489a$export$3a50f2efd6cfd6f3 = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
const $8be836e57712489a$export$5bd148c13bb23f7a = 'b6a8ea1d-9ec0-4bb6-9e22-01fd310c0591';
const $8be836e57712489a$export$b4de0744c1fd450d = 'e6321572-aa72-47b3-b261-e142b81ad4b2';
const $8be836e57712489a$export$1a7c42187130faf9 = 'b4ac51f3-c235-4f9e-97d0-d450e76aa13a';
const $8be836e57712489a$export$e84c34a7e1dbcf78 = '1b1c9a31-ebef-44b4-9eaa-4ee884672259';
const $8be836e57712489a$export$23f6d7b16d2210c1 = '5002b4f2-9df8-4bb2-8798-56005ef6cbfc';
const $8be836e57712489a$export$1b65c2053cba0686 = '88d39839-ba5c-4704-bfd6-7fe57ed8016b';
const $8be836e57712489a$export$86e0eeb08f5b7ea6 = 'ee8a71e7-85aa-4121-b455-e6316922e894';
const $8be836e57712489a$export$9a234699f0515bf = 'd0f0863a-fe78-4d40-b4f0-451c268594cc';
const $8be836e57712489a$export$f24169c529e6c9b5 = 'd5f62dde-d505-413b-a417-c2dd6979cac2';
const $8be836e57712489a$export$f849b75576b691b = '106df6fd-feed-4aa7-bbf7-5ca2bec6266b';
const $8be836e57712489a$export$c0e3a1d9aa18e8eb = '7620f432-f831-4711-8e09-3aa379bf2d96';
const $8be836e57712489a$export$7f190c8f7bc2242 = 'a8c2aa57-6975-4ed7-80c6-42f46f0bdf91';
const $8be836e57712489a$export$8df25926ec47a767 = 'aab1458f-e9f0-49e0-b86e-b191e9186a4a';
const $8be836e57712489a$export$12d01b6c311a909a = Object.freeze({
    CLOUD_ID: 'cloud-id',
    OPT_OUT: 'Opt-out',
    REASON: 'reason',
    FEELING: 'feeling',
    IS_ADMIN: 'is-admin',
    IS_SITE_ADMIN: 'is-site-admin',
    IS_PROJECT_SETTINGS: 'is-project-settings',
    INLINE_FEEDBACK_ID: 'inlineFeedbackId',
    IS_JSD_EVALUATOR: 'is-jsd-evaluator',
    IS_SIMPLIFIED_PROJECT: 'is-simplified-project',
    SUPPORTED_PROJECT_TYPES: 'supported-project-types',
    FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location',
    FEEDBACK_COLLECTOR_ID: 'feedback-collector-id',
    FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key',
    LOCATION: 'Location',
    PROJECT_TYPE: 'project-type',
    BOARD_TYPE: 'board-type',
    REFERER: 'Referer',
    ROUTE_GROUP: 'route-group',
    ROUTE_NAME: 'route-name',
    USER_AGENT: 'User-Agent',
    SCREEN_RESOLUTION: 'Screen Resolution',
    SOURCE: 'Source',
    SUB_PRODUCT: 'Sub-product',
    JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow',
    JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign',
    DEPLOYMENT_PROVIDERS: 'deployment-providers',
    JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar',
    VERSION_CONTROL_PROVIDERS: 'version-control-providers',
    DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab',
    CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers',
    SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers',
    INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers',
    IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component',
    FEEDBACK_GROUP_ID: 'feedback-group-id',
    EDITION: 'edition',
    ENV: 'environment',
    SMART_REPLIES: 'smart-replies',
    PROJECT_RECAP_FEEDBACK_GROUP_ID: 'jira-notifications-project-recap',
    STANDUPS: 'standups'
});

});

parcelRegister("4Qvpr", function(module, exports) {
$parcel$export(module.exports, "useFeedbackCollector", () => $8ee5902a66d773ff$export$4be696be8a3bff13);
$parcel$export(module.exports, "useFeedbackCollectorActions", () => $8ee5902a66d773ff$export$dfb2ee2d9e73fa48);
$parcel$export(module.exports, "FeedbackActionsSubscriber", () => $8ee5902a66d773ff$export$c35dbf16ebe9df04);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");
const $8ee5902a66d773ff$export$d4c72bab9d6cc13a = {
    isFeedbackCollectorOpen: false,
    entrypointId: undefined,
    email: undefined,
    additionalFields: undefined,
    feedbackTitle: undefined,
    feedbackContext: undefined,
    feedbackCollectorId: undefined,
    // default value of this prop is true so making sure inititally it is true
    showTypeField: true,
    submitButtonLabel: undefined,
    canBeContactedLabel: undefined,
    canBeContactedLink: undefined,
    enrolInResearchLink: undefined,
    summaryPlaceholder: undefined,
    feedbackGroupLabels: undefined,
    onClose: undefined,
    feedbackTitleDetails: undefined,
    triggerRef: undefined,
    renderCustomContent: undefined,
    customFeedbackOptions: []
};
const $8ee5902a66d773ff$export$e324594224ef24da = {
    openFeedbackCollector: (feedbackCollectorProps)=>({ setState: setState, dispatch: dispatch })=>{
            // Reset to initial state to clear any leftover state
            dispatch($8ee5902a66d773ff$export$e324594224ef24da.resetFeedbackCollectorState());
            setState({
                ...feedbackCollectorProps,
                isFeedbackCollectorOpen: true
            });
        },
    closeFeedbackCollector: ()=>({ getState: getState, setState: setState })=>{
            const { triggerRef: triggerRef } = getState();
            if (triggerRef) // Unfortunately we need a setTimeout here to delay the execution cycle because modal is yet to be closed
            setTimeout(()=>triggerRef.current?.focus(), 50);
            setState({
                isFeedbackCollectorOpen: false,
                triggerRef: undefined
            });
        },
    resetFeedbackCollectorState: ()=>({ setState: setState })=>{
            setState({
                ...$8ee5902a66d773ff$export$d4c72bab9d6cc13a
            });
        },
    updateCustomRenderComponent: (updatedCustomRenderContent)=>({ setState: setState })=>{
            setState({
                renderCustomContent: updatedCustomRenderContent
            });
        },
    updateAdditionalFields: (updatedAdditionalFields)=>({ setState: setState })=>{
            setState({
                additionalFields: updatedAdditionalFields
            });
        }
};
const $8ee5902a66d773ff$var$Store = (0, $GtRbT.createStore)({
    name: 'feedback-collector',
    initialState: $8ee5902a66d773ff$export$d4c72bab9d6cc13a,
    actions: $8ee5902a66d773ff$export$e324594224ef24da
});
const $8ee5902a66d773ff$export$4be696be8a3bff13 = (0, $iJq0l.createHook)($8ee5902a66d773ff$var$Store);
const $8ee5902a66d773ff$export$dfb2ee2d9e73fa48 = (0, $iJq0l.createActionsHook)($8ee5902a66d773ff$var$Store);
const $8ee5902a66d773ff$export$c35dbf16ebe9df04 = (0, $ht3nQ.createSubscriber)($8ee5902a66d773ff$var$Store, {
    selector: null
});

});

parcelRegister("e7yO3", function(module, exports) {
$parcel$export(module.exports, "fireFeedbackCreatedAnalytics", () => $30a2ba2f9389342e$export$f69def16ab840819);

var $2Mqjh = parcelRequire("2Mqjh");

var $gdeTc = parcelRequire("gdeTc");
const $30a2ba2f9389342e$var$allowedAttributes = [
    'feedback-collector-id',
    'reason',
    'feeling',
    (0, $gdeTc.EntryKeys).IS_ATLASKIT_FEEDBACK_COMPONENT
];
const $30a2ba2f9389342e$var$getAnalyticsPayloadFromAdditionalEntries = (additionalFeedbackEntries)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const payload = {};
    additionalFeedbackEntries.forEach((entry)=>{
        if ($30a2ba2f9389342e$var$allowedAttributes.includes(entry.key)) payload[entry.key] = entry.value || 'empty';
    });
    return payload;
};
const $30a2ba2f9389342e$export$f69def16ab840819 = async (entrypointId, request)=>{
    const fullAnalyticsId = 'jira-jsd-widget-feedback.feedback';
    const { additionalFeedbackEntries: additionalFeedbackEntries } = request;
    const gasV3Event = {
        action: 'created',
        actionSubject: fullAnalyticsId,
        // Note: the `source` is not related to JSD project. The `source` is used wrongly here.
        // Since it's minor and we don't break reports used by other teams, so we accept this.
        source: 'jira-jsd-widget-feedback',
        attributes: {
            ...$30a2ba2f9389342e$var$getAnalyticsPayloadFromAdditionalEntries(additionalFeedbackEntries),
            entrypointId: entrypointId
        }
    };
    const analyticsClient = await (0, $2Mqjh.getAnalyticsWebClientPromise)();
    analyticsClient.getInstance().sendOperationalEvent(gasV3Event);
};

});

const $0eb3f773a9c78b82$export$c14d5836f440dde1 = 'customfield_10047';
const $0eb3f773a9c78b82$export$542a20d67952f202 = 'feedback-renderer.linked-issues-btn';

parcelRegister("lWu0k", function(module, exports) {
$parcel$export(module.exports, "LazyFeedbackCollectorDialog", () => $78ff411b96b2a71f$export$b3688097311920df);

var $bQWwW = parcelRequire("bQWwW");

const $78ff411b96b2a71f$export$b3688097311920df = (0, $bQWwW.lazy)(()=>(parcelRequire("dea97")), {
    ssr: false,
    moduleId: "../platform/packages/web-platform/feedback-collector/src/index.ts"
});

});
parcelRegister("dea97", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("i5RZQ")
]).then(()=>parcelRequire('ib7KB'));

});


parcelRegister("1XQ0l", function(module, exports) {
$parcel$export(module.exports, "successFlagConfigWithoutAppify", () => $396374283e5b7dd5$export$658a6327cb895b59);
$parcel$export(module.exports, "successFlagConfig", () => $396374283e5b7dd5$export$9147e75154c63ed3);

var $jVAR7 = parcelRequire("jVAR7");
const $396374283e5b7dd5$export$658a6327cb895b59 = {
    type: 'success',
    title: (0, $jVAR7.default).feedbackSuccessFlagTitle,
    description: (0, $jVAR7.default).feedbackSuccessFlagDescription,
    isAutoDismiss: true,
    messageId: 'feedback-collector.ui.feedback-renderer.success-flag',
    messageType: 'transactional'
};
const $396374283e5b7dd5$export$9147e75154c63ed3 = {
    type: 'success',
    title: (0, $jVAR7.default).feedbackSuccessFlagTitle,
    description: (0, $jVAR7.default).feedbackSuccessFlagDescriptionAppify,
    isAutoDismiss: true,
    messageId: 'feedback-collector.ui.feedback-renderer.success-flag',
    messageType: 'transactional'
};

});
parcelRegister("jVAR7", function(module, exports) {
$parcel$export(module.exports, "default", () => $eeb07e9109cc87de$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $eeb07e9109cc87de$var$messages = (0, $7qGN1.defineMessages)({
    feedbackSuccessFlagDescription: {
        "id": "platform.feedback.feedback-collector.feedback-renderer.success-flag.feedback-success-flag-description",
        "defaultMessage": "Your valuable feedback helps us continually improve our products."
    },
    feedbackSuccessFlagTitle: {
        "id": "platform.feedback.feedback-collector.feedback-renderer.success-flag.feedback-success-flag-title",
        "defaultMessage": "Thanks!"
    },
    feedbackSuccessFlagDescriptionAppify: {
        "id": "platform.feedback.feedback-collector.feedback-renderer.success-flag.feedback-success-flag-description-appify",
        "defaultMessage": "Your valuable feedback helps us continually improve our apps."
    }
});
var $eeb07e9109cc87de$export$2e2bcd8739ae039 = $eeb07e9109cc87de$var$messages;

});


parcelRegister("dymtJ", function(module, exports) {
$parcel$export(module.exports, "createAnalyticsPayload", () => $f9fbce655029b09b$export$182a3169dfe1f3d8);

var $gdeTc = parcelRequire("gdeTc");
const $f9fbce655029b09b$export$182a3169dfe1f3d8 = (feedbackCollectorId, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
feedbackDetails)=>({
        additionalFeedbackEntries: [
            {
                key: (0, $gdeTc.EntryKeys).FEEDBACK_COLLECTOR_ID,
                value: feedbackCollectorId ?? 'empty'
            },
            {
                key: (0, $gdeTc.EntryKeys).IS_ATLASKIT_FEEDBACK_COMPONENT,
                value: 'true'
            },
            ...feedbackDetails.type ? [
                {
                    key: (0, $gdeTc.EntryKeys).REASON,
                    value: feedbackDetails.type
                }
            ] : []
        ]
    });

});



//# sourceMappingURL=async-feedback-collector-renderer.80f0432d.js.map
